<!-- @format -->

<template>
    <div
        class="d-flex flex-column u-position-relative"
        :style="{ flex: 1, 'min-height': 0 }">
        <SelectedEventTicketCard
            v-if="selectedTicket"
            :ticket="selectedTicket"
            :quantity="ticketsQuantity"
            :show-icon="true"
            class="ma-2 mb-0"
            @change="$emit('change-event-ticket')" />
        <AddHotelReservation
            :style="{ flex: 1, 'min-height': 0 }"
            :value="selectedHotelReservation"
            :event="event"
            :start-date-time="event.startDateTime"
            :end-date-time="endDateReservation"
            :default-view="defaultView"
            :allow-toggle-view="!$vuetify.breakpoint.mdAndUp"
            :quantity="ticketsQuantity"
            :in-location="venueLocation"
            :distance-unit-of-measure="distanceUnitOfMeasure"
            :bundle-products="bundleProducts"
            :highlighted-item="highlightedHotelReservation"
            suppress-auto-highlight
            @change-show-filter="$emit('change-show-filter', $event)"
            @highlight-item="$emit('highlight-hotel-reservation', $event)"
            @input="onInputDo"
            @hotels-loaded="$emit('hotels-loaded', $event)" />
    </div>
</template>

<script>
import { getDistanceUnitOfMeasureForCountry } from '@core/utils/measureUtils';
import { defaultCheckOutDate } from '@tenant/app/utils/bookingUtils';
import { create as CreateBundleProductsModel } from '@tenant/app/modelsV2/BundleProductsModel';
import locationsConstants from '@tenant/app/utils/constants/locations';
import hotelsConstants from '@tenant/app/utils/constants/hotels';
import AddHotelReservation from '@tenant/app/modules/hotel/features/addHotelReservation/AddHotelReservation';
import SelectedEventTicketCard from './_components/SelectedEventTicketCard';

export default {
    name: 'EventHotels',
    components: {
        AddHotelReservation,
        SelectedEventTicketCard,
    },
    props: {
        event: {
            type: Object,
            required: true,
        },
        selectedHotelReservation: {
            type: Object,
            default: null,
        },
        selectedTicket: {
            type: Object,
            default: null,
        },
        ticketsQuantity: {
            type: Number,
            default: 2,
        },
        busEventsParent: {
            type: Object,
            required: true,
        },
        bundleProducts: {
            type: Object,
            default: function () {
                return CreateBundleProductsModel();
            },
        },
        highlightedHotelReservation: {
            type: Object,
            default: null,
        },
    },
    computed: {
        currency() {
            return this.event.currency;
        },
        endDateReservation() {
            const { startDateTime, endDateTime } = this.event;
            return defaultCheckOutDate(
                endDateTime || startDateTime,
                this.venueLocation.city,
                this.venueLocation.stateCode,
                this.venueLocation.countryCode
            );
        },
        venueLocation() {
            const {
                venueCity,
                venueCountry,
                venueName,
                venueState,
                venueStreet,
                venueLatitude,
                venueLongitude,
            } = this.event;

            return {
                name: venueName,
                stateCode: venueState,
                countryCode: venueCountry,
                city: venueCity,
                street: venueStreet,
                latitude: venueLatitude,
                longitude: venueLongitude,
                type: locationsConstants.TYPES.VENUE,
            };
        },
        distanceUnitOfMeasure() {
            return getDistanceUnitOfMeasureForCountry(this.venueLocation.countryCode);
        },
        hotelsViews() {
            return hotelsConstants.VIEWS;
        },
        defaultView() {
            return this.$vuetify.breakpoint.mdAndUp ? this.hotelsViews.list : this.hotelsViews.map;
        },
    },
    methods: {
        onInputDo(item) {
            this.$emit('select-hotel-reservation', item);
            this.$emit(
                'highlight-hotel-reservation',
                item ? item.item : this.highlightedHotelReservation
            );
        },
    },
};
</script>
